import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { QuestionChip } from 'components/ui/QuestionChip'
import { useSuggestedQuestions } from 'hooks/useSuggestedQuestions'

const DefaultQuestionsComponent = () => {
  const { t } = useTranslation()
  const { questions, visible, loading, disabled, sendQuestion } = useSuggestedQuestions()

  if (!visible && !loading) return null

  return (
    // Keyed on the question set: a new set remounts the block and replays the entrance cascade
    <div
      key={loading ? 'thinking' : questions.join('\n')}
      className="flex flex-col items-start gap-2"
      aria-live="polite"
    >
      <div className="animate-fade-slide-in flex items-center gap-1.5 text-xs tracking-wide text-muted-foreground uppercase opacity-0">
        <span className="relative inline-flex text-primary">
          <OdinIcon icon={['far', 'sparkles']} className="h-3 w-3" />
          {loading && (
            <>
              <OdinIcon icon={['far', 'sparkles']} className="spark-mini spark-mini-1" />
              <OdinIcon icon={['far', 'sparkles']} className="spark-mini spark-mini-2" />
              <OdinIcon icon={['far', 'sparkles']} className="spark-mini spark-mini-3" />
            </>
          )}
        </span>
        <span className={loading ? 'shimmer' : undefined}>
          {loading ? t('generatingQuestions') : t('suggestedQuestions')}
        </span>
      </div>
      {!loading &&
        questions.map((question, index) => (
          <QuestionChip
            key={question}
            question={question}
            disabled={disabled}
            onClick={() => sendQuestion(question)}
            animationDelayMs={100 + index * 80}
          />
        ))}
    </div>
  )
}

export const DefaultQuestions = memo(DefaultQuestionsComponent)
DefaultQuestions.displayName = 'DefaultQuestions'
